import { z } from "zod";
import { status } from "../validators";

export const serverResponse = z.object({
  status,
});
